module.exports = __webpack_public_path__ + "fonts/ProximaNovaW05-BlackItalic.63dfc964.ttf";